import { Directive, EventEmitter, Input, Output } from '@angular/core';
import type { TileConfig, TileData } from '../../../interfaces/Tile.interface';

@Directive()
export abstract class SpawnableTile<TileType extends TileData> {
    @Input() tileData!: TileType;
    @Input() tileConfig!: TileConfig;

    @Output() deleted = new EventEmitter<void>();
    @Output() edited = new EventEmitter<TileType>();
}
